module.exports = __webpack_public_path__ + "static/media/plus.3b446478.svg";